/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { writable } from 'svelte/store';
export const currentStepIndex = writable(-1);
export const isSubmitInitiated = writable(false);
export const showRecaptcha = writable(false);
export const hasGeneratedFirstResult = writable(false);
export const selectionForm = writable({
    captchaToken: '',
    imageOrMessage: '',
    createA: '',
    forYour: '',
    whoLikes: '',
    makeFeel: '',
    occasion: '',
});
export const floraVerseSession = writable({
    url: '',
    brand: '',
    browserUUID: '',
    userType: '',
    isMobile: false,
    token: '',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    flags: {} as Record<string, any>

})